import React from 'react';
import { AlertCircle } from 'lucide-react';

interface EmptyStateProps {
  message?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No data available.',
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center text-muted-foreground">
      <AlertCircle className="w-8 h-8 mb-2 text-gray-400" />
      <p className="text-sm">{message}</p>
    </div>
  );
};
